import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NiveisServicoService {

  niveisServicoGet$ = new BehaviorSubject(null);
  niveisServicoListaGet$ = new BehaviorSubject(null);
  niveisServicoPost$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/NiveisServicos/Obter/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.niveisServicoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.niveisServicoGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.niveisServicoGet$.unsubscribe(),
          this.niveisServicoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  getLista() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/niveis_de_servico/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.niveisServicoListaGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.niveisServicoListaGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.niveisServicoListaGet$.unsubscribe(),
          this.niveisServicoListaGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  post(lista: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/NiveisServicos/Persistir"
      lista.empresa = environment.empresa;

      this.http.post(url, lista, { headers: headers })
        .subscribe({
          next: (res: any) => this.niveisServicoPost$.next(res),
          error: (error: HttpErrorResponse) => {
            this.niveisServicoPost$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.niveisServicoPost$.unsubscribe(),
            this.niveisServicoPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }
}
